// Everything that needs an account elsewhere lives here, so switching a
// feature on is a one-line edit. Each one is inert while it is empty: no
// script is loaded, no request is made, and the UI for it stays hidden.
//
// scripts/gen-pages.js also reads this file at build time, so the GA4 and
// AdSense tags land in the static HTML <head> of every page, where Google's
// crawlers (and the AdSense site check) can see them without running JS.

// Google Analytics 4 Measurement ID, e.g. "G-XXXXXXXXXX".
// Analytics > Admin > Data streams > your web stream.
export const GA_MEASUREMENT_ID = "G-KY7KL57BD4";

// AdSense publisher ID, e.g. "ca-pub-1234567890123456".
// AdSense > Account > Settings > Account information.
// Setting it adds the Auto ads script to every page and writes /ads.txt.
export const ADSENSE_CLIENT = "ca-pub-6756898853264978";

// Where the "new exercises" sign-up form posts to. Any service that accepts
// a JSON POST works - a Formspree form URL (https://formspree.io/f/xxxxxxxx),
// a Mailchimp/Buttondown endpoint, or a Cloudflare Worker.
// While this is empty the sign-up box is not rendered at all.
export const SUBSCRIBE_ENDPOINT = "";
